export const FETCH_TOKEN = "FETCH_TOKEN";
export const UPDATE_TOKEN = "UPDATE_TOKEN";
